import { RootState } from '../../RootState';

const selectLastQueryMetadata = (state: RootState): Record<string, string> =>
  state.search.lastQueryMetadata;

export default selectLastQueryMetadata;
